<template>
  <div>
    <button-component
      v-if="!loading"
      :variant="btnVariant"
      @btn-click="downloadHandler"
      v-bind="$attrs"
      :title="$t(title)"
    >
      <slot>{{ $t(title) }}</slot>
    </button-component>
    <LoaderComponent v-else/>
  </div>
</template>

<script>
import ButtonComponent from '@/components/base-components/buttons/ButtonComponent';
import LoaderComponent from '@/components/LoaderComponent';
import {mapMutations} from 'vuex';
import {ADD_TOAST} from '@/store/mutationTypes';
import {initDownload} from '@/utils/helpers';
import {ERROR} from '@/const';

export default {
  name: 'DownloadButton',
  components: {
    LoaderComponent,
    ButtonComponent,
  },
  props: {
    title: {
      type: String,
      default: 'Download',
    },
    url: {
      type: String,
    },
    apiMethod: {
      type: Function,
    },
    id: {
      type: Number,
    },
    btnVariant: {
      type: String,
    },
    onRequestFinish: {
      type: Function,
    },
    onRequestSuccess: {
      type: Function,
    },
    onRequestError: {
      type: Function,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapMutations({
      addToast: ADD_TOAST,
    }),
    errorToast() {
      this.addToast({
        text: ERROR.SOMETHING_WRONG,
        time: 7000,
        type: 'error',
      });
    },
    downloadHandler() {
      this.loading = true;

      if (this.url) {
        this.createDownload(this.url);
      } else {
        this.apiMethod({id: this.id}).then((res) => {
          this.createDownload(res);
        }).catch(() => {
          this.loading = false;
          this.errorToast();
        }).finally(() => {
          this.onRequestFinish?.();
        });
      }
    },
    createDownload(url) {
      try {
        initDownload(url);
      } catch (err) {
        this.errorToast();
      } finally {
        this.onRequestFinish?.();
      }
      this.loading = false;
    },
  },
};
</script>
